module.exports = __webpack_public_path__ + "static/media/tanakh.9d0b83d9.svg";